import { render, staticRenderFns } from "./StepsBlock.vue?vue&type=template&id=33dc628f&scoped=true&"
import script from "./StepsBlock.vue?vue&type=script&lang=js&"
export * from "./StepsBlock.vue?vue&type=script&lang=js&"
import style0 from "./StepsBlock.vue?vue&type=style&index=0&id=33dc628f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc628f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33dc628f')) {
      api.createRecord('33dc628f', component.options)
    } else {
      api.reload('33dc628f', component.options)
    }
    module.hot.accept("./StepsBlock.vue?vue&type=template&id=33dc628f&scoped=true&", function () {
      api.rerender('33dc628f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/StepsBlock.vue"
export default component.exports